(function () {
    'use strict';

    angular
        .module('app.shared')
        .factory('HoleScoreDto', HoleScoreDtoFactory);

    var identity = angular.identity,
        includedStats = new Set(['putts', 'puttLength', 'club', 'drive', 'fir', 'upDown', 'sandSave', 'penalty']);

    HoleScoreDtoFactory.$inject = ['holesPlayed', 'fairwayHitType'];
    function HoleScoreDtoFactory(holesPlayed, fairwayHitType) {
        function HoleScoreDto(score, holeScore) {
            if (!(this instanceof HoleScoreDto))
                return new HoleScoreDto(score, holeScore);
            this._score = score;
            this._holeScore = holeScore;
        }

        Object.defineProperties(HoleScoreDto.prototype = {}, {
            // Hole
            number: accessor('number', true, false),
            yards: accessor('yards', true, true),
            par: accessor('par', true, true),
            handicap: accessor('handicap', true, false),

            // Score
            gross: accessor('gross', false, true),
            grossDisabled: disabledAccessor('gross'),

            esc: accessor('esc', true, true),

            // Stats
            putts: accessor('putts', false, true, true),
            puttsExcluded: excludedAccessor('putts'),
            puttsDisabled: disabledAccessor('putts'),

            puttLength: accessor('puttLength', false, true, true),
            puttLengthExcluded: excludedAccessor('puttLength'),
            puttLengthDisabled: disabledAccessor('puttLength'),

            club: accessor('club', false, false, true),
            clubExcluded: excludedAccessor('club'),
            clubDisabled: disabledAccessor('club'),

            drive: accessor('drive', false, false, true),
            driveExcluded: excludedAccessor('drive'),
            driveDisabled: disabledAccessor('drive'),

            fir: accessor('fir', false, true, true),
            firExcluded: excludedAccessor('fir'),
            firDisabled: disabledAccessor('fir'),

            upDown: accessor('upDown', false, true, true),
            upDownExcluded: excludedAccessor('upDown'),
            upDownDisabled: disabledAccessor('upDown'),

            sandSave: accessor('sandSave', false, true, true),
            sandSaveExcluded: excludedAccessor('sandSave'),
            sandSaveDisabled: disabledAccessor('sandSave'),

            penalty: accessor('penalty', false, true, true),
            penaltyExcluded: excludedAccessor('penalty'),
            penaltyDisabled: disabledAccessor('penalty'),

            // Misc
            disabled: { get: getIsHoleDisabled },
            toJSON: { value: toJSON },

            // Private
            _score: { writable: true },
            _hole: { get: function () { return this._score.holes[this._holeScore.index] } },
            _holeScore: { writable: true }
        });

        // Accessors
        function accessor(field, readonly, canSum, isStat) {
            var result = { get: get };
            if (!readonly)
                result.set = set;
            return result;

            /////////////////
            function get() {
                var number = this._holeScore.number,
                    isHoleData = field in this._hole,
                    disabled = this[field + 'Disabled'],
                    list, sum = 0;

                // Is this an invalid hole number?  Ie, Front9 + Hole 11 = Invalid
                if (disabled && !isHoleData)
                    return null;

                // Is this a non-computed hole? Ie, not IN, OUT, or TOT
                if (number % 1 === 0 || field === 'number') {
                    return field !== 'esc' ? (!isHoleData ? this._holeScore[field] : this._hole[field]) : getEsc.call(this);
                }

                // Is this a non-summable field?  Ie, Club, Drive, or Hcp
                if (!canSum) return null;

                // We need to sum it
                list = !isHoleData ? this._score.holeScores : this._score.holes;
                for (var i = number === 18.1 ? 11 : 1; i <= (number === 9.1 ? 9 : 19); i += (i != 9 ? 1 : 2))
                    sum += convert(list[i][field]);

                return sum || null;

                function convert(value) {
                    return field === 'upDown' || field === 'sandSave' ? (value ? 1 : 0) :
                        field === 'fir' ? (value === fairwayHitType.Hit ? 1 : 0) :
                            value || 0;
                }
            }
            function set(value) {
                if (field in this._hole)
                    throw new Error('Cannot set hole data fields');
                if (this._holeScore.number % 1 !== 0)
                    throw new Error('Cannot set computed field');
                this._holeScore[field] = value;
            }

            function getEsc() {
                var max = this._hole.max;

                var hp = this._score.holesPlayed;
                if (hp === holesPlayed.FrontNine && this._hole.frontMax) {
                    max = this._hole.frontMax;
                }
                if (hp === holesPlayed.BackNine && this._hole.backMax) {
                    max = this._hole.backMax;
                }
                return max == null ? this.gross : this.gross != null ? Math.min(this.gross, max) : null;
            }
        }

        function excludedAccessor(field) {
            return { get: get };

            function get() {
                // Add Field test here....
                return this.disabled || !this._score.isTrackingStats || !includedStats.has(field);
            }
        }

        function disabledAccessor(field) {
            return { get: get };

            function get() {
                return this.disabled // Hole is disabled
                    || this[field + 'Excluded'] // Stat is turned off
                    || ((field === 'drive' || field === 'fir') && this._hole.par <= 3);  // Is < Par3 drive or fir

            }
        }

        function getIsHoleDisabled() {
            var number = this._holeScore.number,
                isHoleByHole = this._score.isHoleByHole,
                hp = this._score.holesPlayed;

            return !isHoleByHole || !(hp === holesPlayed.EighteenHoles || number === 18.2 || number === 0 || (hp === holesPlayed.FrontNine && number <= 9.1) || (hp === holesPlayed.BackNine && number >= 10));
        }

        // Methods
        function toJSON() {
            var isTrackingStats = this._score.isTrackingStats,
                score = {
                    number: this.number,
                    yards: this.yards,
                    par: this.par,
                    handicap: this.handicap,
                    gross: this.gross
                },
                stats = isTrackingStats ? {
                    putts: this.putts,
                    puttLength: this.puttLength,
                    club: this.club,
                    drive: this.drive,
                    fir: this.fir,
                    upDown: this.upDown,
                    sandSave: this.sandSave,
                    penalty: this.penalty
                } : {};

            return Object.assign(score, stats);
    }

    return HoleScoreDto;
}
})();
